import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface SectionRuleProps extends HTMLAttributes<HTMLHRElement> {
  /** Tailwind margin utility for vertical rhythm. Default "my-12". */
  spacing?: string;
}

/**
 * Editorial hairline divider used between sections on home-v4. Reads
 * --rule from the active theme so it darkens/lightens automatically.
 */
export function SectionRule({ spacing = "my-12", className, ...rest }: SectionRuleProps) {
  return <hr className={cn("border-0 border-t border-rule", spacing, className)} {...rest} />;
}
